const BreadcrumbsStore = {
  data: {
    items: []
  },

  setItems (items) {
    BreadcrumbsStore.data.items = items;
  },

  addItems (items) {
    BreadcrumbsStore.data.items = BreadcrumbsStore.data.items.concat(items);
  }
};

export default BreadcrumbsStore;
